import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import Message from "../message";

function QCAutomation() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [testFile, set_testFile] = useState("");
  const [status_testFile, setStatus_testFile] = useState("");

  const submit_testFile = async () => {
    setStatus_testFile("");

    if (testFile.length <= 0) {
      setStatus_testFile("Upload Delivery Excel File!");
    } else {
      setStatus_testFile("Processing Files...");

      const formDatatestFile = new FormData();
      formDatatestFile.append("file", testFile);

      const requestOptions = {
        method: "POST",
        body: formDatatestFile,
      };

      try {
        const testFile_response = await fetch(
          apiServer + `api/qc_automation/upload_file/`,
          requestOptions
        );
        const testFile_status_id = await testFile_response.json();
        const testFile_status = testFile_status_id.detail
          ? testFile_status_id.detail
          : testFile_status_id;
        setStatus_testFile(testFile_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Form.Control
        type="file"
        name="verifier"
        id="verifier"
        className="verifierxcls"
        onChange={(e) => set_testFile(e.target.files[0])}
      />
      <Button
        variant="primary"
        type="button"
        style={{ marginTop: "20px" }}
        onClick={() => submit_testFile()}
      >
        Submit
      </Button>
      {Message(status_testFile, setStatus_testFile)}
    </div>
  );
}
export default QCAutomation;
